import React from 'react';

export function StepActivitiesLabel() {
  return (
    <>
      Nová provozovna - <b>Činnosti</b>
    </>
  );
}
